import React, { useState } from "react";
import axios from "axios";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { Briefcase, Mail, Lock, User, Eye, EyeOff, Store, Phone, ChevronRight, ArrowLeft, Loader2, PlusCircle, Gift, ShoppingBag, RadioTower } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { toast } from "sonner";
import { useNavigate, Link } from "react-router-dom";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

export const SellerRegister = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [formData, setFormData] = useState({
        fullname: "",
        email: "",
        password: "",
        phone: "",
        store_name: ""
    });

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${API}/sellers/register`, formData);
            if (response.data.success) {
                localStorage.setItem("seller_token", response.data.token);
                localStorage.setItem("seller_data", JSON.stringify(response.data.seller));
                toast.success("Kont Machann ou an kreye ak siksè!");
                navigate("/seller/dashboard");
            }
        } catch (error) {
            toast.error(error.response?.data?.detail || "Erè nan kreyasyon kont la.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-gray-50 flex flex-col">
            <Header />

            <div className="flex-1 flex flex-col md:flex-row items-center justify-center p-4 lg:p-12 bg-gradient-to-b from-gray-50 to-white gap-8 lg:gap-16">

                {/* Left Side Content - Benefits */}
                <div className="max-w-md w-full hidden lg:block">
                    <div className="bg-[#232F3E] p-10 rounded-[50px] text-white shadow-2xl relative overflow-hidden">
                        <div className="absolute top-0 right-0 p-10 opacity-10">
                            <RadioTower className="w-64 h-64" />
                        </div>
                        <h2 className="text-4xl font-black mb-10 tracking-tighter leading-none italic">Kòmanse Vann sou <span className="text-[#FF9900]">BVGLink</span></h2>

                        <div className="space-y-8 relative">
                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-2xl bg-[#FF9900] flex items-center justify-center text-white shrink-0 shadow-lg shadow-[#FF9900]/20">
                                    <ShoppingBag className="w-5 h-5" />
                                </div>
                                <div>
                                    <h4 className="font-black uppercase text-sm tracking-widest text-[#FF9900]">Pwodwi Fizik</h4>
                                    <p className="text-gray-400 text-sm font-medium mt-1">Vann telefòn, rad, ak tout sa ou genyen nan stock ou.</p>
                                </div>
                            </div>

                            <div className="flex items-start gap-4">
                                <div className="w-10 h-10 rounded-2xl bg-blue-500 flex items-center justify-center text-white shrink-0 shadow-lg shadow-blue-500/20">
                                    <Gift className="w-5 h-5" />
                                </div>
                                <div>
                                    <h4 className="font-black uppercase text-sm tracking-widest text-blue-400">Pwodwi Dijital</h4>
                                    <p className="text-gray-400 text-sm font-medium mt-1">Vann kont Netflix, jwèt, ak tout sèvis sou entènèt.</p>
                                </div>
                            </div>

                            <div className="bg-white/5 p-6 rounded-3xl border border-white/10 mt-10">
                                <p className="text-xs font-bold text-gray-400 text-center uppercase tracking-[0.2em]">Plus de 10,000 kliyan Ayisyen</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="max-w-lg w-full">
                    <Card className="rounded-[40px] border-none shadow-2xl overflow-hidden bg-white">
                        <CardHeader className="p-10 pb-2 text-center text-black">
                            <div className="w-16 h-16 bg-[#FF9900]/10 rounded-2xl flex items-center justify-center mx-auto mb-6">
                                <PlusCircle className="w-8 h-8 text-[#FF9900]" />
                            </div>
                            <CardTitle className="text-2xl font-black uppercase tracking-tight">KREYASYON KONT MACHANN</CardTitle>
                            <CardDescription className="text-gray-400 font-medium">Ranpli enfòmasyon sa yo pou w vin yon vandè ofisyèl.</CardDescription>
                        </CardHeader>
                        <CardContent className="p-10 pt-6">
                            <form onSubmit={handleSubmit} className="space-y-6">
                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1 font-bold">Non fèm ou / Fullname</label>
                                        <div className="relative group">
                                            <User className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 group-focus-within:text-[#FF9900] transition-colors" />
                                            <Input
                                                placeholder="John Doe"
                                                className="pl-11 h-12 rounded-2xl bg-gray-50 border-none focus:ring-2 focus:ring-[#FF9900] font-bold text-black text-sm"
                                                value={formData.fullname}
                                                onChange={(e) => setFormData({ ...formData, fullname: e.target.value })}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1">Non Magazen w lan</label>
                                        <div className="relative group">
                                            <Store className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 group-focus-within:text-[#FF9900] transition-colors" />
                                            <Input
                                                placeholder="Egz: Boutique John"
                                                className="pl-11 h-12 rounded-2xl bg-gray-50 border-none focus:ring-2 focus:ring-[#FF9900] font-bold text-black text-sm"
                                                value={formData.store_name}
                                                onChange={(e) => setFormData({ ...formData, store_name: e.target.value })}
                                                required
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="space-y-2">
                                    <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1">Imèl Machann</label>
                                    <div className="relative group">
                                        <Mail className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 group-focus-within:text-[#FF9900] transition-colors" />
                                        <Input
                                            type="email"
                                            placeholder="machann@egzanp.com"
                                            className="pl-11 h-12 rounded-2xl bg-gray-50 border-none focus:ring-2 focus:ring-[#FF9900] font-bold text-black text-sm"
                                            value={formData.email}
                                            onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1 font-bold">Telefòn</label>
                                        <div className="relative group">
                                            <Phone className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 group-focus-within:text-[#FF9900] transition-colors" />
                                            <Input
                                                placeholder="+509 XXXX XXXX"
                                                className="pl-11 h-12 rounded-2xl bg-gray-50 border-none focus:ring-2 focus:ring-[#FF9900] font-bold text-black text-sm"
                                                value={formData.phone}
                                                onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                                                required
                                            />
                                        </div>
                                    </div>

                                    <div className="space-y-2">
                                        <label className="text-[10px] font-black uppercase tracking-widest text-gray-400 ml-1">Modpas</label>
                                        <div className="relative group">
                                            <Lock className="absolute left-4 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 group-focus-within:text-[#FF9900] transition-colors" />
                                            <Input
                                                type={showPassword ? "text" : "password"}
                                                placeholder="••••••••"
                                                className="pl-11 pr-12 h-12 rounded-2xl bg-gray-50 border-none focus:ring-2 focus:ring-[#FF9900] font-bold text-black text-sm"
                                                value={formData.password}
                                                onChange={(e) => setFormData({ ...formData, password: e.target.value })}
                                                required
                                            />
                                            <button
                                                type="button"
                                                onClick={() => setShowPassword(!showPassword)}
                                                className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 hover:text-[#FF9900] focus:outline-none z-10"
                                            >
                                                {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <Button
                                    type="submit"
                                    disabled={loading}
                                    className="w-full bg-[#FF9900] hover:bg-[#E88B00] text-white h-16 rounded-[25px] font-black text-lg transition-all hover:scale-[1.02] shadow-xl shadow-[#FF9900]/20"
                                >
                                    {loading ? <Loader2 className="animate-spin w-6 h-6" /> : <PlusCircle className="mr-3 w-6 h-6" />}
                                    ENREJISTRE KOUNYE A
                                </Button>
                            </form>

                            <div className="mt-10 pt-8 border-t border-gray-50 text-center">
                                <p className="text-gray-400 text-xs font-bold uppercase tracking-wider mb-4">Ou gen kont deja?</p>
                                <Link to="/seller/login">
                                    <Button variant="outline" className="w-full h-12 rounded-xl border-2 border-gray-100 font-bold text-gray-600 hover:bg-gray-50">
                                        KONEKTE KOUNYE A <ChevronRight className="ml-2 w-4 h-4" />
                                    </Button>
                                </Link>

                                <Link to="/marketplace" className="inline-flex items-center gap-2 text-gray-400 hover:text-gray-600 mt-8 text-[10px] font-black uppercase tracking-widest transition-colors">
                                    <ArrowLeft className="w-3 h-3" /> Tounen nan Marketplace
                                </Link>
                            </div>
                        </CardContent>
                    </Card>
                </div>
            </div>

            <Footer />
        </div>
    );
};
